const removeLoader = () => {
  $('#loader').remove()
}

export default removeLoader



// WEBPACK FOOTER //
// ./app/utils/loader/removeLoader.js